import styled from "styled-components";

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.cart.item.border};
  background: ${({ theme }) => theme.palette.cart.item.background};
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Image = styled.img`
  width: 4rem;
  height: 4rem;
  object-fit: cover;
  border-radius: 0.5rem;
  flex-shrink: 0;
`;

export const Info = styled.div`
  width: 150px;
`;

export const Title = styled.h5`
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.1rem;
  color: ${({ theme }) => theme.palette.neutral.lightest};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Price = styled.p`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.success.light};
  margin-top: 0.25rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ActionButton = styled.button`
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  border-radius: 0.375rem;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 0.9rem;
    height: 0.9rem;
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }

  &:hover {
    background: ${({ theme }) => theme.palette.neutral.dark};
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Quantity = styled.input`
  width: 2.5rem;
  height: 2rem;
  text-align: center;
  font-size: 0.9rem;
  background: transparent;
  color: ${({ theme }) => theme.palette.neutral.lightest};
  border: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  border-radius: 0.375rem;
  outline: none;
`;

export const RemoveButton = styled(ActionButton)`
  background: ${({ theme }) => theme.palette.error.medium};
  border-color: ${({ theme }) => theme.palette.error.medium};

  svg {
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }

  &:hover {
    background: ${({ theme }) => theme.palette.error.medium};
  }
`;
